import React from "react";

import momentjs from "moment";
import { useIntl } from "react-intl";

import { Link } from "ds/Button";

import * as S from "./InvoiceHeader.styles";

const formatDate = date => momentjs(date).format("MMM D, YYYY");
const longPeriod = (start, end) => formatDate(start) + " - " + formatDate(end);

const InvoiceHeader = ({ order }) => {
  const intl = useIntl();
  const date = longPeriod(order.billing_period_start, order.billing_period_end);

  return (
    <S.Header>
      <S.InvoiceNumber>
        {order.id}
        <S.InvoiceDescription>
          {" "}
          {intl.formatMessage({
            id: `billing.invoice.invoice_number`
          })}
        </S.InvoiceDescription>
      </S.InvoiceNumber>

      <S.InvoiceDuration>
        {date}
        <S.InvoiceDescription>
          {" "}
          {intl.formatMessage({
            id: `billing.invoice.duration`
          })}
        </S.InvoiceDescription>
      </S.InvoiceDuration>
      {order.invoice_url && (
        <S.DownloadButton>
          <Link
            variant="primary"
            target="_blank"
            href={order.invoice_url}
            analyticId="download.pdf"
          >
            {intl.formatMessage({ id: "download.pdf" })}
          </Link>
        </S.DownloadButton>
      )}
    </S.Header>
  );
};
export default InvoiceHeader;
